import React from 'react';

interface InstallationStatusLabelProps {
    status: string;
}

const InstallationStatusLabel: React.FC<InstallationStatusLabelProps> = ({ status }) => {
    const colorMap: Record<string, string> = {
        'NOT_STARTED': 'muted',
        'SENT_TO_DEVICE': 'info',
        'IN_PROGRESS': 'info',
        'UPDATED': 'success',
        'FAILED': 'danger',
        'REBOOT_PENDING': 'warning',
    };
    
    const normalizedStatus = status?.toUpperCase() || 'NOT_STARTED';
    const color = colorMap[normalizedStatus];
    const label = normalizedStatus?.replace(/_/g, ' ');

    return (
        <span className={`label label-${color} label-filled height-100pct`}>
            {label}
        </span>
    );
};

export default InstallationStatusLabel;
